import * as React from "react";

import { InitialStateMinimumRequirements_ForgotPasswordOptionInJoining } from "../initial-state-requirements";

export interface EmailAlreadyRegisteredErrorMessageProps {
  useInitialState: () => {
    initialState: InitialStateMinimumRequirements_ForgotPasswordOptionInJoining;
  };
  handleUserWantsToLoginInsteadBecauseTheirEmailIsAlreadyRegistered: () => void;
}
export const EmailAlreadyRegisteredErrorMessage: React.FunctionComponent<
  EmailAlreadyRegisteredErrorMessageProps
> = (props) => {
  const { initialState } = props.useInitialState();
  const { forgot_password_url } = initialState || {};

  const onUserWantsToLogin: React.MouseEventHandler<HTMLAnchorElement> =
    React.useCallback(
      (event) => {
        event.preventDefault();
        event.stopPropagation();
        props.handleUserWantsToLoginInsteadBecauseTheirEmailIsAlreadyRegistered();
      },
      [
        props,
        props.handleUserWantsToLoginInsteadBecauseTheirEmailIsAlreadyRegistered,
      ]
    );
  return (
    <p className="error-message">
      <span>{"Looks like you already have an account with us. Please "}</span>
      <a
        href="javascript:void(0);"
        className="link link--login"
        onClick={onUserWantsToLogin}
      >
        {"login"}
      </a>
      <span>{" or "}</span>
      <a href={forgot_password_url} className="link link--forgotpassword">
        {"reset your password"}
      </a>
      <span>{"."}</span>
    </p>
  );
};
